// This function converts the string to a sentence case.

export default function convertToSentenceCase(value) {
    if (typeof value !== 'string' || !value.trim()) {
        return '';
    }
 
    const formatted = value.trim().toLowerCase();
 
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}